import { Button, IconPhone16 } from '@cian/ui-kit';

import { FC } from 'react';

import { IPhoneButton } from './types';

export const PhoneButton: FC<IPhoneButton> = props => {
  const { children, onClick, disabled = false } = props;

  return (
    <Button
      beforeIcon={<IconPhone16 color="white_100" />}
      disabled={disabled}
      size="XS"
      theme="fill_primary"
      onClick={onClick}
    >
      {children}
    </Button>
  );
};

PhoneButton.displayName = 'PhoneButton';
